import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import signIn from 'action-creators/account/sign-in';

class GoogleSignInButton extends React.Component {
  constructor(props) {
    super(props);

    this.buttonID = `g-signin2-${this.props.buttonID}`;
    this.onGoogleSignIn = this.onGoogleSignIn.bind(this);
    this.state = {
      signOut: this.props.signOut,
      error: null,
    };
  }

  componentDidMount() {
    try {
      if (this.state.signOut) {
        gapi.load('auth2', () => {
          gapi.auth2.init();
          gapi.auth2.getAuthInstance().then(() => {
            if (gapi.auth2.getAuthInstance().isSignedIn.get()) { gapi.auth2.getAuthInstance().signOut(); }
            this.setState({ signOut: false });
            this.renderGoogleSignIn();
          });
        });
      } else {
        this.renderGoogleSignIn();
      }
    } catch (e) {
      this.setState({ error: 'There was a problem contacting Google. Please try again later.' });
    }
  }

  renderGoogleSignIn() {
    gapi.signin2.render(this.buttonID, {
      scope: 'profile email',
      longtitle: true,
      height: null,
      width: null,
      onsuccess: this.onGoogleSignIn,
    });
  }

  onGoogleSignIn(googleUser) {
    if (this.state.signOut) { return; }
    const googleProfile = googleUser.getBasicProfile();

    this.props.signIn({
      credentialType: 'google',
      email: googleProfile.getEmail(),
      first_name: googleProfile.getGivenName(),
      last_name: googleProfile.getFamilyName(),
      google_id_token: googleUser.getAuthResponse().id_token,
      redirectURI: this.props.redirectURI,
      marketingAllowed: this.props.marketingAllowed,
    });
  }

  render() {
    return <div id={this.buttonID} className="google-sign-in-button">{this.state.error}</div>;
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({ signIn }, dispatch)
);

const mapStateToProps = (state) => {
  const {
    errors,
  } = state.account;

  return {
    errors,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleSignInButton);
